import { queryDatabaseItems } from "../../../services/database/queryDatabaseItems";
import { Player } from "../Types/GameTypes_dep";

export async function listPlayers(lobbyId: string) {
  try {
    const result = await queryDatabaseItems<Player>("/player", lobbyId);

    return result;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
